import styled from "styled-components"
import { device } from "breakpoints"

export const HeaderWrapper = styled.div`
  border-top: 5px solid #f5f5f5;
  padding-top: 24px;

  @media ${device.desktop} {
    padding-top: 53px;
  }
`
